import React from 'react';
import './theme.css';

const Intro = () => {
  return (
    <section style={styles.container}>
      <div style={styles.content}>
        <div style={styles.textContent}>
          <h1 style={styles.heading}>
            Hello there, it's nice to (virtually) meet you!
          </h1>
          <p style={styles.name}>My name is Muqueet</p>
          <p style={styles.text}>
            I am a tech enthusiast currently studying at the University of New South Wales (UNSW) and a proud alumnus of University of California, Berkeley, where I majored in Data and Computer Science. Welcome to my digital domain!
          </p>
          <p style={styles.text}>
            After completing my undergraduate studies at Berkeley, I've embarked on an exciting journey towards a Masters in Computer Science at UNSW. My research interests include Database Systems and Programming Languages. At UNSW, I am a subcommittee member of{' '}
            <a href="https://devsoc.app" style={styles.link}>DevSoc</a>'s{' '}
            <a href="https://freerooms.devsoc.app" style={styles.link}>Freerooms</a> Mobile Team.
          </p>
        </div>
        <div style={styles.imageContainer}>
          <div style={styles.imagePlaceholder}>
            {/* Add your profile image here */}
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  container: {
    padding: '2rem 1rem',
    backgroundColor: 'var(--background-color)',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '3rem',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: '2rem',
      textAlign: 'center',
    },
  },
  textContent: {
    maxWidth: '600px',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
  heading: {
    fontSize: '3.5rem',
    lineHeight: '1.2',
    marginBottom: '1rem',
    color: 'var(--gray-900)',
    fontWeight: '800',
    '@media (max-width: 768px)': {
      fontSize: '2rem',
    },
  },
  name: {
    fontSize: '2rem',
    color: 'var(--gray-700)',
    marginBottom: '1rem',
    fontWeight: '600',
    '@media (max-width: 768px)': {
      fontSize: '1.5rem',
    },
  },
  text: {
    fontSize: '1.125rem',
    lineHeight: '1.7',
    color: 'var(--gray-600)',
    marginBottom: '1rem',
    '@media (max-width: 768px)': {
      fontSize: '1rem',
    },
  },
  link: {
    color: 'var(--primary-color)',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'color 0.2s ease-in-out',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      order: -1,
      marginBottom: '2rem',
    },
  },
  imagePlaceholder: {
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    backgroundImage: 'url("/F80E41B8-9FFE-4482-B583-9B0FAD923BB6.PNG")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '0 20px 40px var(--header-shadow)',
    border: '4px solid var(--card-bg)',
    '@media (max-width: 768px)': {
      width: '250px',
      height: '250px',
    },
  },
};

export default Intro;
